<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item v-if="addEditObj.isAdd" label="老人姓名" prop="epid">
      <el-select v-fixZoom v-model="addEditForm.epid" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="changePerson">
        <el-option v-for="item in elderly" :key="item.index" :label="item.name" :value="item.id">
          <span>{{ getSelectElderlyShow(item) }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-else label="老人姓名">
      <span>{{elderly_name}}</span>
    </el-form-item>
    <el-form-item v-if="addEditForm.change_type === 1" label="充值前余额" prop="">
      <span>{{addEditForm.before_amount}}</span>
    </el-form-item>
    <el-form-item v-if="addEditForm.change_type === 2" label="消费前余额" prop="">
      <span>{{addEditForm.before_amount}}</span>
    </el-form-item>
    <el-form-item v-if="addEditForm.change_type === 1 || addEditForm.change_type === 2" :label="addEditForm.change_type === 1 ? '充值金额' : '消费金额'" prop="change_amount">
      <el-input type="number" v-model="addEditForm.change_amount" placeholder="请输入金额（元）"></el-input>
    </el-form-item>
    <el-form-item v-if="addEditForm.change_type === 3" label="余额显示" prop="">
      <span>{{num}}</span>
    </el-form-item>
    <el-form-item label="备注" prop="">
      <el-input type="textarea" :rows="2" v-model="addEditForm.change_remark" placeholder="请输入备注"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {addelderlyfinanceorder, queryelderlyfinanceorder, refundelderlyfinanceorder} from '../../../api/yanglaoyuan'
import {queryelderlyhasbed} from '../../../api/yanglaoyuan/elderly'

export default {
  name: 'financeOrder',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      elderly_name: '',
      addEditForm: {
        'eid': 0,
        'epid': '',
        'ef_id': 0,
        'change_type': 1, // 1、充值。2、消费。3、退款
        'change_amount': '',
        'before_amount': 0,
        'after_amount': 0,
        'change_time': '',
        'change_remark': ''
      },
      addEditRules: {
        epid: [
          {required: true, message: '请选择老人', trigger: 'change'}
        ],
        change_amount: [
          {required: true, message: '请输入金额', trigger: 'blur'}
        ]
      },
      orgArr1: [],
      orgArr2: [],
      num: 0,
      elderly: [],
      sendDate: []
    }
  },
  created () {
    // 1、oldPersonCheck.vue老人账单  2、rechargePay.vue充值消费
    const end = new Date()
    const start = new Date()
    start.setDate(1)
    this.sendDate = [start.format('yyyy-MM-dd'), end.format('yyyy-MM-dd')]
    console.log(this.addEditObj)
    this.addEditForm.change_type = this.addEditObj.change_type
    if (!this.addEditObj.isAdd) {
      this.addEditForm.eid = this.addEditObj.row.eid
      this.addEditForm.epid = this.addEditObj.row.epid
      this.addEditForm.ef_id = this.addEditObj.row.id
      this.addEditForm.before_amount = this.addEditObj.row.balance
      this.elderly_name = this.addEditObj.row.elderly_name
      if (this.addEditObj.change_type === 3) {
        this.num = this.addEditObj.row.balance
        // this.num = this.addEditObj.row.balance + this.addEditObj.row.deposit
      }
    } else {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
      this.getElderlyData()
    }
  },
  methods: {
    getElderlyData () {
      let data = {
        e_id: this.$store.state.user.LoginResp.entity_id
      }
      queryelderlyhasbed({}, data).then(res => {
        this.elderly = res.data.elderly
      })
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room + '号间' : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name + '号床' : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    changePerson () {
      console.log(this.addEditForm.epid)
      let params = {
        size: 1,
        page: 9999
      }
      let data = {
        eid: this.$store.state.user.LoginResp.entity_id,
        epid: this.addEditForm.epid,
        ep_name: ''
        // change_time_from: this.sendDate[0] + ' 00:00:00',
        // change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinanceorder(params, data).then(res => {
        // this.tableData = res.data.elderlyFinanceList
        // this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      if (this.addEditForm.change_type === 2) {
        if (parseFloat(this.addEditForm.change_amount) > this.addEditForm.before_amount) {
          this.$message({
            message: '消费金额不能大于消费前余额。',
            type: 'warning'
          })
          return
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            'eid': this.addEditForm.eid,
            'epid': this.addEditForm.epid,
            'ef_id': this.addEditForm.ef_id,
            'change_type': this.addEditForm.change_type, // 1、充值。2、消费。3、退款
            'change_amount': parseFloat(this.addEditForm.change_amount),
            'before_amount': this.addEditForm.before_amount,
            'after_amount': 0,
            'change_remark': this.addEditForm.change_remark
          }
          if (data.change_type === 1 || data.change_type === 2) {
            if (data.change_type === 1) {
              data.after_amount = this.addEditForm.before_amount + parseFloat(this.addEditForm.change_amount)
            } else {
              data.after_amount = this.addEditForm.before_amount - parseFloat(this.addEditForm.change_amount)
            }
            addelderlyfinanceorder(data).then(res => {
              this.$notify({title: '成功', message: '充值成功', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else if (data.change_type === 3) {
            refundelderlyfinanceorder(data).then(res => {
              this.$notify({title: '成功', message: '退款成功', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/financeOrder.vue